import { getFormattedTime, getFormattedDate } from "modules/studentRefund/common/services";
import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping, fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const getDropdowns = async () => {
    const resp = await Promise.all([
        dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "id",
            "businessAreaDesc"
        ),
        dropdownMapping(
            endpoint.country.getAllActive,
            "countryDesc",
            "countryCode",
        ),
        fetchAllPostPromisedData(
            `${endpoint.bankMaster.search}?offset=-1`,
            {}
        )

    ]);
    const bankList = resp[2]?.data?.bankMasterList ?? [];
    return {
        activeBusinessAreas: resp[0],
        allCountries: resp[1],
        allBanks: bankList?.map(bank => ({ ...bank, label: bank?.bankName, value: bank?.id })),
    };
}

export const studentDetails = [
    { key: "psid", label: "PSID" },
    { key: "studentName", label: "Student Name" },
    { key: "applicationId", label: "Application No." },
    { key: "refundNumber", label: "Refund tracker No." },
    { key: "studentFatherName", label: "Parent name" },
    { key: "courseId", label: "Regular Course ID", showCourseEye: true },
    { key: "sdCourseId", label: "SD Course ID" },
    { key: "term", label: "Term" },
    { key: "academicCareerValue", label: "Career" },
    { key: "academicGroupValue", label: "Stream" },
    { key: "refundAmount", label: "Refund Amount" },
    { key: "businessAreaDispVal", label: "BU", showEye: true, descKey: "bu" },
    { key: "cashierOffice", label: "Cashier's office" },
    { key: "batchList", label: "Batch", showEye: true },
];

export const getReinitRefundReqBody = (details, bankDetails = {}, attachmentKey, userDetails) => {
    const { refundNumber, orderType, psid, subOrderType, applicationId, studentName, studentFatherName, courseId, refundAmount, updatedOn, term, userId, businessArea, businessAreaDispVal, cashierOffice, academicCareerValue } = details;
    // const { bankMasterId, country, bankKey, bankAccountType, accountNumber, ifscCode, accountType, beneficiaryName, bankStatus, accountRelation } = bankDetails;

    return {
        refundNumber: refundNumber,
        orderType: orderType,
        subOrderType: subOrderType,
        psid: psid,
        applicationId: applicationId,
        studentName: studentName,
        fatherName: studentFatherName,
        businessAreaValue: businessAreaDispVal,
        businessArea: businessArea,
        cashierOffice: cashierOffice,
        regularCourseId: courseId,
        sdCourseId: "",
        termValue: term,
        refundAmount: +(refundAmount),
        // userActionDate: updatedOn,
        userId: userDetails?.employeeId,
        refundStatus: "REINITIATED",
        remark: "REINITIATED",
        academicCareerValue,
        attachments: [],
        refundDto: {
            psid: psid,
            bankMasterId: bankDetails?.bankMasterId ?? "",
            country: bankDetails?.country ?? "",
            bankKey: bankDetails?.bankKey ?? "",
            bankAccountType: bankDetails?.bankAccountType ?? "",
            accountNumber: bankDetails?.accountNumber ?? "",
            accountType: bankDetails?.accountType ?? "",
            ifscCode: bankDetails?.ifscCode ?? "",
            beneficiaryName: bankDetails?.beneficiaryName ?? "",
            attachmentKey: attachmentKey ?? "",
            bankStatus: bankDetails?.bankStatus ?? "",
            accountRelation: bankDetails?.accountRelation ?? "",
            paymentMode: "EFT"
        }
    }


};


export const getReinitTimelineSteps = (updatedBy, updatedOn) => {
    return [
        {
            label: 'Confirmation form has been sent to the parents',
            subSteps: [
                { label: `${getFormattedDate(updatedOn)} at ${getFormattedTime(updatedOn)}` },
            ],
        },
        {
            label: 'Refund has been re-initiated',
            subSteps: [
                { label: `By ${updatedBy}` },
                { label: `${getFormattedDate(updatedOn)} at ${getFormattedTime(updatedOn)}` },
            ],
        },
    ];
}